import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NgbModule, NgbRatingModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxImageZoomModule } from "ngx-image-zoom";
import { CarouselModule } from "ngx-owl-carousel-o";
import { NgxPaginationModule } from "ngx-pagination";
import { AppService } from "src/app/app.service";
import { AlertsModule } from "src/app/Components/alerts/alerts.module";
import { CartService } from "../../Cart-module/cart-page/cart-page.service";
import { SharedVariantsModule } from "../product-lists/product-list/shared-variants/shared-variants.module";
import { ProductDetailsRoutingModule } from "./product-details.routing.module";
import { ProductBoxOneModule } from "../../Home-Modules/home-two/product-box-one/product-box-one.module";

import { ProductDetailsComponent } from "./product-details/product-details.component";
import { ProductReviewComponent } from "./product-review/product-review.component";
// import { NgxSpinnerModule } from 'ngx-spinner';

@NgModule ({

    declarations: [
        ProductReviewComponent,
        ProductDetailsComponent
    ],
    imports: [
        CommonModule,
        AlertsModule, 
        ProductDetailsRoutingModule,
        NgxImageZoomModule,
        ReactiveFormsModule,
        NgbModule,
        CarouselModule,
        FormsModule,
        RouterModule,
        SharedVariantsModule,
        ProductBoxOneModule
        // NgxSpinnerModule,
    ],
    providers: [
    ]

})
export class ProductDetailsModule { };